module.exports = __webpack_public_path__ + "static/media/near-me-active.2b616566.svg";